export default {
  CONTEST_LIST: '/api/common/contest/list',                        // 赛事列表接口

  SEASON_INFO: '/api/common/season/info',                          // 赛季详情接口

  CURRICULA_INFO: '/api/curricula/curriculaInfo',                  // 获取课程内容和详情内容

  SECTION_LIST: '/api/common/section/list',                        // 获取赛程时间列表

  CATEGORY_LIST: '/api/common/section/category/list',              // 日程内赛程列表

  BANK_GET_QUESTION: '/api/exam/bank/getQuestion',                 // 获取题目

  SAVE_CURRICULA_ANSWER: '/api/exam/saveCurriculaAnswer',          // 获取题目

  ANSWER_LIST: '/api/exam/answerList',                             // 获取答案列表

  MANAGE_CHECK_WORK: '/api/work/manage/checkWork',                 // 是否可以提交课程/任务题目

  UPDATE_STATUS: '/api/common/task/done',                          // 任务状态提交已完成

  COMMON_FLAG: '/api/common/flag',                                 // 标记是否（是否使用，是否完成、是否看过等等），第一次调用后就标为是

  WINNER_LIST: '/api/material/winner/list',                        // 获奖名单

  CERTIFICATE_LIST: '/api/contest/certificate/list',               // 获取证书

  CERTIFICATE_SEND: '/api/contest/certificate/send',           // 证书发送邮箱

  REPORTCARD_INFO: '/api/reportCard/reportCardInfo',                // 成绩单，

  ACADEMIC_CARD: '/api/academic/user/info',        // 学术报告

  ACADEMIC_INFO: '/api/academic/user/info',                // 学术报告

  WORK_WRITRING_SAVE: '/api/work/writing/save',                // 保存写作内容

  WORK_WRITRING_DISPLAY: '/api/work/writing/display',           // 显示写作内容（本地没用缓存）

  WORK_WRITRING_REMIND: '/api/work/writing/remind/confirm'      // 确认提醒信息
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/event.js